var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.DefaultLayout,{attrs:{"salesMenu":true,"obtainOrderMenu":true}},[_c(_setup.ObtainSearch),_c(_setup.ObtainSearchDataTable)],1),_c(_setup.ObtainDetailDialog)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }